import { format, subDays, startOfMonth, startOfYear, endOfYear } from 'date-fns';

type Option = {
    label: string;
    value: string;
    range: () => { startDate: string; endDate: string };
};

interface Props {
    onSelect: (start: string, end: string, value: string) => void;
    selected: string | null;
}

export default function FilterColumnDashboardDate({
    onSelect,
    selected,
}: Props) {
    const today = new Date();
    const options: Option[] = [
        {
            label: 'Hoje',
            value: 'today',
            range: () => ({
                startDate: format(today, 'yyyy-MM-dd'),
                endDate: format(today, 'yyyy-MM-dd'),
            }),
        },
        {
            label: 'Ontem',
            value: 'yesterday',
            range: () => {
                const yesterday = subDays(today, 1);
                return {
                    startDate: format(yesterday, 'yyyy-MM-dd'),
                    endDate: format(yesterday, 'yyyy-MM-dd'),
                };
            },
        },
        {
            label: 'Últimos 7 dias',
            value: 'last7',
            range: () => ({
                startDate: format(subDays(today, 6), 'yyyy-MM-dd'),
                endDate: format(today, 'yyyy-MM-dd'),
            }),
        },
        {
            label: 'Últimos 30 dias',
            value: 'last30',
            range: () => ({
                startDate: format(subDays(today, 29), 'yyyy-MM-dd'),
                endDate: format(today, 'yyyy-MM-dd'),
            }),
        },
        {
            label: 'Este mês',
            value: 'thisMonth',
            range: () => {
                const startOfThisMonth = startOfMonth(today);
                const endOfThisMonth = today.getDate() === 1
                    ? startOfThisMonth
                    : today;

                return {
                    startDate: format(startOfThisMonth, 'yyyy-MM-dd'),
                    endDate: format(endOfThisMonth, 'yyyy-MM-dd'),
                };
            },
        },
        {
            label: 'Este ano',
            value: 'thisYear',
            range: () => ({
                startDate: format(startOfYear(today), 'yyyy-MM-dd'),
                endDate: format(endOfYear(today), 'yyyy-MM-dd'),
            }),
        },
    ];


    return (
        <div className="space-y-2 grid grid-cols-3 mb-5  rounded-md p-3 bg-warmGray-200 shadow-md">
            {options.map((option) => (
                <label key={option.value} className="flex items-center gap-2">
                    <input
                        type="checkbox"
                        checked={selected === option.value}
                        onChange={() => {
                            const { startDate, endDate } = option.range();
                            onSelect(startDate, endDate, option.value);
                        }}
                    />
                    <span className="text-sm">{option.label}</span>
                </label>
            ))}

        </div>
    );
}
